import React from 'react';
import './About.css';
import useReveal from '../hooks/useReveal';
import imgWide  from '../assets/images/building-wide.jpg';
import imgGate  from '../assets/images/schoolgate.jpeg';
import imgFront from '../assets/images/schoolground.jpeg';
import bishopImg from '../assets/images/bishop.jpeg';
import secretaryImg from '../assets/images/secretary.jpeg';
import staffImg from '../assets/images/staff.jpeg';
import staff2Img from '../assets/images/staff2.jpeg';

const pills = [
  { title: 'Nursery – 10th', sub: 'Classes Offered' },
  { title: 'English Medium', sub: 'Instruction' },
  { title: 'Bagalkot Dist.', sub: 'Karnataka' },
  { title: 'DISE 29020117506', sub: 'Official Code' },
];

const leadership = [
  {
    name: 'Most. Rev. Dr. Derek Fernandes',
    role: 'Bishop of Belgaum and Chairman of Belgaum Diocese Board of Education and Social Service',
    image: bishopImg,
    alt: 'Chairman Most. Rev. Dr. Derek Fernandes',
  },
  {
    name: 'Fr. Gerard Dsilva',
    role: 'Secretary · B.D.B.E & S.W',
    image: secretaryImg,
    alt: 'Secretary Fr. Gerard Dsilva',
  },
];

export default function About() {
  const imgRef = useReveal();
  const txtRef = useReveal();
  return (
    <section className="section about-section" id="about">
      <div className="container about-grid">
        <div className="about-imgs reveal" ref={imgRef}>
          <div className="ai-big"><img src={imgWide} alt="School Building" /></div>
          <div className="ai-sm"><img src={imgGate} alt="School Gate" /></div>
          <div className="ai-sm"><img src={imgFront} alt="Campus Front" /></div>
                    <div className="ai-sm"><img src={staffImg} alt="Campus Front" /></div>
          <div className="ai-sm"><img src={staff2Img} alt="Campus Front" /></div>

          {/* <div className="about-badge"><strong>14+</strong><small>Years of Service</small></div> */}
          {/* <div className="about-pills-left">
            {pills.map((p) => (
              <div key={p.title} className="pill">
                {p.title}<small>{p.sub}</small>
              </div>
            ))}
          </div> */}
        </div>
        <div className="about-txt reveal" ref={txtRef}>
          <span className="stag">About The School</span>
          <h2 className="stitle">A Beacon of Quality Education in Rural Karnataka</h2>
          <div className="sline" style={{ marginBottom: 24 }} />
          <p>St. Xavier's English Medium School, Guledgudd, is a minority educational institution established and administered by the Belgaum Diocese Board of Education. While rooted in Christian values, we warmly welcome all — without distinction of caste, creed, or race.</p>
          <p>Our school began in 2011 with classes 6th–10th, steadily growing in trust and community support. In 2025, we achieved a major milestone — unifying our Nursery-to-10th campus under one roof.</p>
          <p>Guided by our motto <strong>Sacrifice · Love · Service</strong>, we form young minds who become lights of the world.</p>

          <div className="leadership-grid">
            {leadership.map((person) => (
              <article key={person.name} className="leadership-card">
                <img src={person.image} alt={person.alt} />
                <div className="leadership-card-body">
                  <h3>{person.name}</h3>
                  <p>{person.role}</p>
                </div>
              </article>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
